import apiClient from '../utils/apiClient';

/**
 * Menu Item Creator Revenue API
 * Quản lý chia sẻ doanh thu cho nhân viên sáng tạo món
 */
export const menuItemRevenueAPI = {
  /**
   * Lấy danh sách chia sẻ doanh thu theo kỳ, nhóm theo nhân viên
   * @param {string} period - Kỳ YYYY-MM
   * @param {string} [branchId] - ID chi nhánh (tùy chọn)
   */
  getList: async (period, branchId) => {
    return await apiClient.get({
      url: '/menu-item-revenue',
      params: { period, ...(branchId ? { branchId } : {}) },
    });
  },

  /**
   * Trigger tính toán revenue share cho kỳ
   * @param {string} period - Kỳ YYYY-MM
   * @param {string} [branchId] - ID chi nhánh (tùy chọn)
   */
  calculate: async (period, branchId) => {
    return await apiClient.post({
      url: '/menu-item-revenue/calculate',
      params: { period, ...(branchId ? { branchId } : {}) },
    });
  },

  /**
   * Tổng revenue share của một nhân viên trong kỳ
   * @param {string} employeeId
   * @param {string} period - Kỳ YYYY-MM
   */
  getEmployeeSummary: async (employeeId, period) => {
    return await apiClient.get({
      url: `/menu-item-revenue/employee/${employeeId}`,
      params: { period },
    });
  },
};
